/* ==========================================================================
   Future Aesthetics — smooth scrolling (Lenis)

   Deliberately conservative about when it runs:
   - off for prefers-reduced-motion
   - off inside the theme editor, where it fights section scroll-into-view
   - off for touch-primary devices, which already have good native inertia
   - paused whenever a drawer or modal locks the body, so those panels scroll
     natively instead of being hijacked
   ========================================================================== */

(function () {
  'use strict';

  if (typeof Lenis === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

  const lenis = new Lenis({
    duration: 1.05,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    smoothWheel: true,
    syncTouch: false,
    touchMultiplier: 1.6,
    wheelMultiplier: 1,
  });

  window.faLenis = lenis;

  let rafId;
  function raf(time) {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  }
  rafId = requestAnimationFrame(raf);

  /* ----------------------------------------------------------------------
     Pause while the body is scroll-locked.
     Dawn locks scrolling by adding an `overflow-hidden*` class to <body>
     (cart drawer, menu drawer, search modal, quick add).
     ---------------------------------------------------------------------- */

  const isLocked = () => /(^|\s)overflow-hidden/.test(document.body.className);

  let locked = false;
  function syncLock() {
    const nowLocked = isLocked();
    if (nowLocked === locked) return;
    locked = nowLocked;
    if (locked) lenis.stop();
    else lenis.start();
  }

  new MutationObserver(syncLock).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
  syncLock();

  /* ----------------------------------------------------------------------
     In-page anchors should ease rather than jump.
     ---------------------------------------------------------------------- */

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const id = link.getAttribute('href');
    if (!id || id === '#' || link.hasAttribute('data-lenis-ignore')) return;

    const target = document.querySelector(id);
    if (!target) return;

    event.preventDefault();
    lenis.scrollTo(target, { offset: -(parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0) - 16 });
  });

  window.addEventListener('pagehide', () => {
    cancelAnimationFrame(rafId);
    lenis.destroy();
  });
})();
